// DRAFT — REVIEW ARTIFACT — NOT DEPLOYED
//
// Wraps any cell rendering in a hover tooltip exposing the Cell's provenance: the non-LLM
// engine, the source_ref, the basis, confidence and computed_at. Every number in the shell
// is auditable in one hover — the reviewer never has to trust a bare figure.

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import type { AnyCell } from "@/types/ir";
import { confidenceLabel, engineLabel } from "./labels";

export function ProvenanceTooltip({
  cell,
  children,
}: {
  cell: AnyCell | undefined;
  children: React.ReactNode;
}) {
  if (!cell?.provenance) return <>{children}</>;
  const p = cell.provenance;
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="cursor-help underline decoration-dotted decoration-muted-foreground/40 underline-offset-2">
            {children}
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs space-y-1">
          <div className="font-heading text-xs font-semibold text-foreground">{engineLabel(p.engine)}</div>
          <div className="font-body text-[11px] text-muted-foreground">{p.source_ref}</div>
          <dl className="font-body text-[11px] text-muted-foreground grid grid-cols-[auto_1fr] gap-x-2">
            <dt className="text-muted-foreground/70">Basis</dt>
            <dd className="text-foreground">{cell.basis || "—"}</dd>
            <dt className="text-muted-foreground/70">Confidence</dt>
            <dd className="text-foreground">{confidenceLabel(cell.confidence)}</dd>
            <dt className="text-muted-foreground/70">Computed</dt>
            <dd className="text-foreground">{p.computed_at || "—"}</dd>
          </dl>
          {cell.note && <div className="font-body text-[11px] text-muted-foreground/80 border-t border-border pt-1">{cell.note}</div>}
          {Array.isArray(p.inputs) && p.inputs.length > 0 && (
            <div className="font-body text-[10px] text-muted-foreground/60 border-t border-border pt-1">
              from: {p.inputs.join(", ")}
            </div>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
